import { render, staticRenderFns } from "./PricingSupport.vue?vue&type=template&id=9c3b8e60"
import script from "./PricingSupport.vue?vue&type=script&lang=js"
export * from "./PricingSupport.vue?vue&type=script&lang=js"
import style0 from "./PricingSupport.vue?vue&type=style&index=0&id=9c3b8e60&prod&lang=scss"
import style1 from "./PricingSupport.vue?vue&type=style&index=1&id=9c3b8e60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports